import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'deleting': false,
  'clientInfo': {},
  'invoicing': false,
  'invoiceSaved': false,
  'savingLineInfo': false,
};

const FORM_INITIAL_STATE = {
  'values': {
    'items': [],
  },
};

function addItemSavedFieldToItems(items) {
  const newList = [...items];
  newList.map((element) => {
    const priceFormatted = parseFloat(element.price).toFixed(2);
    element.price = priceFormatted;
    element.subTotal = parseFloat(element.quantity * element.price).toFixed(2);
    return element.itemSaved = true;
  });
  return newList;
}

function addInfoToItem(list, index, lineInfo) {
  const newList = [...list];
  let newObject = {...newList[index]};
  newObject = lineInfo;
  const priceFormatted = parseFloat(lineInfo.price).toFixed(2);
  newObject.price = priceFormatted;
  newObject.partCodeCkecked = true;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function getItemsWithoutLineInfo(list, index) {
  const newList = [...list];
  let newObject = {...newList[index]};
  const partCode = newObject.partCode;
  newObject = {};
  newObject.partCode = partCode;
  newObject.partCodeCkecked = false;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function updateSubTotal(list, {index, quantity, price}) {
  const newList = [...list];
  const newObject = {...newList[index]};

  if (quantity) {
    newObject.quantity = parseInt(quantity, 10);
  }

  if (price) {
    newObject.price = Number(price);
  }

  const subTotal = parseFloat(newObject.price * newObject.quantity);
  newObject.subTotal = subTotal.toFixed(2);

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function saveItem(list, index) {
  const newList = [...list];
  newList.push({'partCode': '', 'partCodeCkecked': false});

  const newObject = {...newList[index]};
  newObject.itemSaved = true;
  
  return [...newList.slice(0, index), newObject, ...newList.slice(index + 1)];
}

const removeItemFromOrder = (list, index) => {
  const itemsList = [...list];
  itemsList.splice(index, 1);
  
  return itemsList;
};

export const invoicing = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_MANUAL_INVOICE_DATA]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MANUAL_INVOICE_DATA]: (state, action) => {
      const clientData = action.response.data;
      delete clientData.detail;
      return ({
        ...state,
        'loading': false,
        'clientInfo': clientData,
      });
    },
    [ActionTypes.FETCHED_MANUAL_INVOICE_DATA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'clientInfo': {},
    }),
    [ActionTypes.DELETING_ITEM_FROM_MANUAL_ORDER]: (state, action) => ({
      ...state,
      'deleting': true,
    }),
    [ActionTypes.DELETED_ITEM_FROM_MANUAL_ORDER]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.DELETED_ITEM_FROM_MANUAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.EMPTY_ORDERS_DATA]: (state, action) => ({
      ...state,
      'loading': false,
      'deleting': false,
      'clientInfo': {},
      'invoicing': false,
    }),
    [ActionTypes.ADDING_ITEM_TO_MANUAL_ORDER]: (state, action) => ({
      ...state,
      'savingLineInfo': true,
    }),
    [ActionTypes.ADDED_ITEM_TO_MANUAL_ORDER]: (state, action) => ({
      ...state,
      'savingLineInfo': false,
    }),
    [ActionTypes.ADDED_ITEM_TO_MANUAL_ORDER_FAILED]: (state, action) => ({
      ...state,
      'savingLineInfo': false,
    }),
    [ActionTypes.SAVING_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': true,
      'invoiceSaved': false,
    }),
    [ActionTypes.SAVED_INVOICE]: (state, action) => ({
      ...state,
      'invoicing': false,
      'invoiceSaved': true,
    }),
    [ActionTypes.SAVED_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'invoicing': false,
      'invoiceSaved': false,
    }),
  })(state, action);
};

export const invoicingForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.EMPTY_ORDERS_DATA]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': [{}],
      },
    }),
    [ActionTypes.FETCHED_MANUAL_INVOICE_DATA]: (state, action) => {
      const clientDetail = action.response.data.detail || [];
      const newList = addItemSavedFieldToItems(clientDetail);
      newList.push({'partCode': '', 'partCodeCkecked': false});

      return ({
        ...state,
        'values': {
          ...state.values,
          'items': newList,
        },
      });
    },
    [ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': addInfoToItem(state.values.items, action.payload, action.response.data),
      },
    }),
    [ActionTypes.VERIFIED_STOCK_IN_WAREHOUSE_FAILED]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': getItemsWithoutLineInfo(state.values.items, action.payload),
      },
    }),
    [ActionTypes.UPDATE_SUBTOTAL]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': updateSubTotal(state.values.items, action.payload),
      },
    }),
    [ActionTypes.SAVED_INVOICE]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': [{'partCode': '', 'partCodeCkecked': false}],
      },
    }),
    [ActionTypes.ADDED_ITEM_TO_MANUAL_ORDER]: (state, action) => {
      const index = action.payload;
      return ({
        ...state,
        'values': {
          ...state.values,
          'items': saveItem(state.values.items, index),
        },
      });
    },
    [ActionTypes.DELETED_ITEM_FROM_MANUAL_ORDER]: (state, action) => {
      const newItems = removeItemFromOrder(state.values.items, action.payload);
      return ({
        ...state,
        'values': {
          ...state.values,
          'items': newItems,
        },
      });
    },
  })(state, action);
};
